module.exports = __webpack_public_path__ + "media/images/icons/illustration/both-b5d4669bea446074a3eb599f1b37c16a.svg";